import { useState, useMemo } from "react";
import { Search, User, Check } from "lucide-react";
import { Input } from "../ui/input";
import { formatCameraAssegnata } from "../../utils/formatCamera";

export default function OspiteSearchSelect({ ospiti, value, onChange, placeholder = "Cerca ospite per nome..." }) {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    const list = (ospiti || []).filter((o) => !o.archiviata);
    if (!q) return list;
    return list.filter((o) => {
      const nome = (o.nome_completo || `${o.nome || ""} ${o.cognome || ""}`).toLowerCase();
      const camera = (o.camera || "").toLowerCase();
      return nome.includes(q) || camera.includes(q);
    });
  }, [ospiti, search]);

  const selected = (ospiti || []).find((o) => o.id === value);

  return (
    <div className="space-y-2">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={placeholder}
          className="pl-9"
        />
      </div>

      {selected && !search && (
        <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-emerald-50 border border-emerald-200 text-sm">
          <User className="w-4 h-4 text-emerald-600 shrink-0" />
          <span className="font-medium text-emerald-800 truncate flex-1">
            {selected.nome_completo}
            {selected.camera ? ` (${formatCameraAssegnata(selected.camera) || selected.camera})` : ""}
          </span>
          <Check className="w-4 h-4 text-emerald-600 shrink-0" />
        </div>
      )}

      <div className="max-h-[200px] overflow-y-auto rounded-lg border border-slate-200 divide-y divide-slate-100">
        {filtered.length === 0 ? (
          <p className="text-sm text-slate-400 text-center py-4">Nessun ospite trovato</p>
        ) : (
          filtered.map((o) => (
            <button
              key={o.id}
              type="button"
              onClick={() => {
                onChange(o.id);
                setSearch("");
              }}
              className={`w-full flex items-center gap-2 px-3 py-2.5 text-left text-sm transition-colors hover:bg-slate-50 ${
                value === o.id ? "bg-emerald-50" : ""
              }`}
            >
              <User className="w-4 h-4 text-slate-400 shrink-0" />
              <span className="font-medium text-slate-800 truncate">
                {o.nome_completo}
                {o.camera ? (
                  <span className="text-slate-400 font-normal ml-1">
                    ({formatCameraAssegnata(o.camera) || o.camera})
                  </span>
                ) : null}
              </span>
              {value === o.id && <Check className="w-4 h-4 text-emerald-600 ml-auto shrink-0" />}
            </button>
          ))
        )}
      </div>
    </div>
  );
}
